<span class="toolbar-button">
    <button class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow" (click)="clickGoToReleaseNotes()"
      matTooltip="RELEASE NOTES" matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
      <mat-icon> new_releases</mat-icon>
    </button>
  </span>
  